import {useEffect, useState} from "react";
import {Tooltip} from "@material-ui/core";

const withState = require("../../../../../utils/withState");
const {apiGetMerchantBalance} = require("../../../../../api/merchant/balance");
const formatNum = require("mn-utils/formatNum");
const WrapperWithLoading = require("../../../../dumb/WrapperWithLoading/B");
const Select = require("../../../../dumb/Select/H");
const {LINK_WITHDRAW} = require('../../../../../constants/links');
const Ripple = require('../../../../dumb/Ripple');
const {
  Link,
} = require('../../../../../router');

const React = require("react");
const formatNumFiat = require("../../../../../utils/formatNumFiat");
const {account$} = require("../../../../../emitters/account");

const ReserveTooltip = ({reserves = []}) => {

  const data = reserves.find((el) => el.asset === 'EUR') || {reserved: '0', released: '0'};
  const display = [
    {
      title: `Locked: ${formatNumFiat(data.reserved)} EUR`,
      desc: 'The amount of fiat that is still in Rolling Reserve Period and cannot be used'
    },
    {
      title: `Released: ${formatNumFiat(data.released)} EUR`,
      desc: 'The amount that is no longer under Reserve but was not yet exchanged'
    }
  ]


  return (
    <div className="w18">
      <Tooltip
        PopperProps={{
          className: 'w443 (bgTransparent)>.MuiTooltip-tooltip'
        }}
        title={(
          <div className="w443 rlv x26" style={{filter: 'drop-shadow(0px 0px 12px rgba(0, 0, 0, 0.25))'}}>
            <div className="abs st-4 xY-50% sr34 bs bcTransparent bcbF b bb8 bh10 z10" />
            <div className="rlv ov mh-8 mv-4 pt20 ph24 pb30 bgF c0 ff$3 r9 z1">
              <div className="mb21 f12 fw7 c717275">
                Rolling Reserve
              </div>
              {display.map((el, i) => (
                <div key={i} className="mt18">
                  <div className="f12 fw7">{el.title}</div>
                  <div className="mt5 f10 fw4 c717275">{el.desc}</div>
                </div>
              ))}
            </div>
          </div>
        )}
        placement="bottom-end"
      >
        <div className="w18">
          <svg className="dB" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99962 0C4.02971 0 0 4.02971 0 8.99962C0 13.9695 4.02971 18 8.99962 18C13.9695 18 18 13.9695 18 8.99962C18 4.02971 13.9695 0 8.99962 0ZM10.8731 13.9482C10.4099 14.131 10.0411 14.2697 9.76457 14.3657C9.48876 14.4617 9.168 14.5097 8.80305 14.5097C8.24229 14.5097 7.80571 14.3726 7.49486 14.099C7.184 13.8255 7.02933 13.4789 7.02933 13.0575C7.02933 12.8937 7.04076 12.7261 7.06362 12.5554C7.08724 12.3848 7.12457 12.1928 7.17562 11.9771L7.75543 9.92914C7.80648 9.73257 7.85067 9.54591 7.88571 9.37219C7.92076 9.19695 7.93752 9.03619 7.93752 8.8899C7.93752 8.62933 7.88343 8.44648 7.776 8.34362C7.66705 8.24076 7.4621 8.19048 7.15657 8.19048C7.00724 8.19048 6.85333 8.21257 6.69562 8.25905C6.53943 8.30705 6.40381 8.35048 6.29257 8.39314L6.44571 7.76229C6.82514 7.60762 7.18857 7.47505 7.53524 7.36533C7.88191 7.2541 8.20952 7.19924 8.5181 7.19924C9.07505 7.19924 9.50476 7.33486 9.80724 7.60305C10.1082 7.872 10.2598 8.22171 10.2598 8.65143C10.2598 8.74057 10.2491 8.89752 10.2286 9.12152C10.208 9.34629 10.1691 9.55124 10.1128 9.73943L9.536 11.7813C9.48876 11.9451 9.44686 12.1326 9.40876 12.3421C9.37143 12.5516 9.35314 12.7116 9.35314 12.819C9.35314 13.0903 9.41333 13.2754 9.53524 13.3737C9.65562 13.472 9.86667 13.5215 10.1653 13.5215C10.3063 13.5215 10.464 13.4964 10.6423 13.4476C10.819 13.3989 10.947 13.3554 11.0278 13.3181L10.8731 13.9482ZM10.771 5.66019C10.5021 5.9101 10.1783 6.03505 9.79962 6.03505C9.42171 6.03505 9.09562 5.9101 8.82438 5.66019C8.55467 5.41029 8.41829 5.10629 8.41829 4.75124C8.41829 4.39695 8.55543 4.09219 8.82438 3.84C9.09562 3.58705 9.42171 3.46133 9.79962 3.46133C10.1783 3.46133 10.5029 3.58705 10.771 3.84C11.04 4.09219 11.1749 4.39695 11.1749 4.75124C11.1749 5.10705 11.04 5.41029 10.771 5.66019Z" fill="#CCCCCC"/>
          </svg>
        </div>
      </Tooltip>
    </div>
  )
}

export default () => {
  const [data, setData] = useState({});
  const [loading, setLoadingState] = useState(true);

  const account = account$.getValue() || {};

  useEffect(() => {
    apiGetMerchantBalance().then((res) => {
      const {
        balances = [],
        rolling_reserves: reserves = []
      } = (res.balance_merchant || {});

      setData({balances, reserves});
    }).finally(() => setLoadingState(false))
  }, []);

  const {
    balances = [],
    reserves = []
  } = data;

  return (
    <WrapperWithLoading
      loading={loading}
    >
      <div className="layoutRow mh-9 (ph9)>1">
        <div className="w66%">
          <div className="hmin108 h bgF6F6F6 pt23 ph25 pb24 ph20@m r10">
            <div className="h18 layoutRow aiC mb16 f12 fw4 lts0em">
              Available Balance
            </div>
            {balances.map((el, i) => (
              <div key={i} className="layoutRow jcSB aiC mt12">
                <div className="f22 fw7">
                  {formatNumFiat(el.available)} {el.asset_code}
                </div>
                <Ripple
                  component={Link}
                  className="layoutRow fvaC fhaC f12 fw4 lts0em cF w106 h29 ttU usN
                      bgC.disabled r9 ov bg5B47FF bg4B37EF:not[.disabled]:h dn"
                  href={`${LINK_WITHDRAW}/${el.asset_code}`}
                  disabled={!el.available || Number(el.available) <= 0}
                  data-testid="withdrawLink"
                >Payout</Ripple>
              </div>
            ))}
          </div>
        </div>
        <div className="fx1">
          <div className="hmin108 h b1 bsSolid bcD3D3D3 pt23 ph25 pb24 ph20@m r10">
            <div className="h18 layoutRow aiC mb16">
              <div className="f12 fw4 lts0em fx1">
                Open Balance
              </div>
              {account.show_rolling_reserve && (
                <ReserveTooltip reserves={reserves} />
              )}
            </div>
            {balances.map((el, i) => (
              <div key={i} className="hmin29 mt12">
                <div className="f22 fw7">
                  {formatNumFiat(el.reserved)} {el.asset_code}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </WrapperWithLoading>
  )

}
